import script from "./ReportOpnameLicenseView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportOpnameLicenseView.vue?vue&type=script&setup=true&lang=js"

import "./ReportOpnameLicenseView.vue?vue&type=style&index=0&id=77bafa24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bafa24"]])

export default __exports__